import React from "react";
import { useSelector } from "react-redux";
import { selectTimeoutPrompt } from "reducers/auth";
import { Transition } from "react-transition-group";

// Icons
import Cross from "../../assets/Icon_Modal_Cross.png";
import { customUseOnClickOutside } from "components/helpers/CustomFieldRenderers/SearchListFieldRenderer/SearchListRenderer";

type ModalProps = {
  open: boolean;
  closeModal(): void;
  actionButton?: React.ReactNode;
  hideActionButton?: boolean;
  hideFooterButtons?: boolean;
  title: string;
  fullSize?: boolean;
  extraClassNames?: string;
  clearUnderlay?: boolean;
};

type Props = ModalProps;

const Modal: React.FC<Props> = ({
  children,
  open,
  closeModal,
  title,
  actionButton,
  hideActionButton,
  hideFooterButtons,
  fullSize,
  extraClassNames,
  clearUnderlay,
}) => {
  const [delayedOpen, setDelayedOpen] = React.useState(false);
  React.useEffect(() => {
    if (open) {
      setTimeout(() => {
        setDelayedOpen(true);
      }, 1);
    }
  }, [open]);
  const timeoutPrompt = useSelector(selectTimeoutPrompt);
  const bind = customUseOnClickOutside(!timeoutPrompt ? closeModal : () => {}, true);

  return (
    <Transition in={delayedOpen} timeout={100} mountOnEnter unmountOnExit>
      {(state) => (
        <div className={`ModalUnderlay ${state} ${clearUnderlay ? "ClearUnderlay" : ""}`}>
          {/* <div className={"ModalUnderlay " + state}> */}
          <div
            className={`Modal ${fullSize ? "FullSize" : ""} ${
              extraClassNames ? extraClassNames : ""
            }`}
            {...bind}
          >
            {/* <div className={fullSize ? "Modal FullSize" : "Modal"} {...bind}> */}
            <div className="Inner">
              {/* Modal Header START */}
              <div className="Top">
                <h2 className="Title">{title}</h2>
                <div className="Cross">
                  <img src={Cross} alt="Cross" onClick={closeModal} />
                </div>
              </div>
              {/* Modal Header END */}

              {/* Modal Content START */}
              <div className="Content">{children}</div>
              {/* Modal Content END */}

              {/* Modal Footer START */}
              {!hideFooterButtons && (
                <div className="Buttons">
                  {actionButton ? (
                    <>
                      <button className="Btn BtnCancel" onClick={closeModal}>
                        Cancel
                      </button>
                      {actionButton}
                    </>
                  ) : hideActionButton ? (
                    <>
                      <button className="Btn BtnCancel" onClick={closeModal}>
                        Cancel
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        data-testid="delete-cancel"
                        className="Btn BtnCancel"
                        onClick={closeModal}
                      >
                        Cancel
                      </button>
                      <button className="Btn" onClick={closeModal}>
                        Close
                      </button>
                    </>
                  )}
                </div>
              )}
              {/* Modal Footer END */}
            </div>
          </div>
        </div>
      )}
    </Transition>
  );
};

export { Modal };
